<template>
  <div>
    <v-card tile flat>
      <v-toolbar
        card
        flat
        dense
        tile
        color="theme_primary"
        class="white--text"
        height="36"
      >
        <v-spacer></v-spacer>
        <v-toolbar-title class="white-text text-capitalize"
          >{{ actionName }} a new transaction</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-toolbar-side-icon>
          <v-icon color="white">{{
            this.editedBankTransaction.id
              ? "mdi-bank-transfer"
              : "mdi-bank-plus"
          }}</v-icon>
        </v-toolbar-side-icon>
      </v-toolbar>

      <v-card-text>
        <v-layout my-2 align-center>
          <v-flex xs5 offset-xs1>
            <span style="color: #757575;">
              <v-icon small class="pr-1" color="#757575">{{
                isCredit ? "mdi-bank-plus" : "mdi-bank-minus"
              }}</v-icon
              >Transaction Type:
            </span>
          </v-flex>

          <v-flex xs5>
            <v-radio-group
              :disabled="canBeModified"
              height="24"
              hide-details
              row
              class="mt-0 pt-0"
              v-model="radioState"
            >
              <v-radio
                height="24"
                color="success"
                label="Credit"
                :value="0"
              ></v-radio>
              <v-radio
                height="24"
                color="error"
                label="Debit"
                :value="1"
              ></v-radio>

              <v-checkbox
                style="padding-top: 8px;"
                v-model="onlyCharges"
                height="22"
                color="amber darken1"
                label="Only Charges"
              ></v-checkbox>
            </v-radio-group>

          </v-flex>
        </v-layout>
        <v-flex class="px-5">
          <v-divider />
        </v-flex>

        <v-layout my-2 align-center v-show="!onlyCharges">
          <v-flex xs5 offset-xs1>
            <span style="color: #757575;">
              <v-icon small class="pr-1" color="#757575">mdi-cash</v-icon>
              {{
                "Amount in " +
                currencies.find((e) => {
                  return e.id == currentBankInformationCurrencyId;
                }).code
              }}
              <span v-show="!isCredit" class="caption font-weight-bold"
                >(incl. bank charges)</span
              >
              :
            </span>
          </v-flex>

          <v-flex xs5>
            <v-text-field
              hide-details
              solo
              single-line
              type="number"
              label="Transaction Amount"
              class="dense-input"
              background-color="#f4f4f4"
              v-model="currentBankTransaction.amount"
              :disabled="canBeModified"
            >
              <template slot="prepend-inner">{{
                getSymbolFromCode(
                  currencies.find((e) => {
                    return e.id == currentBankInformationCurrencyId;
                  }).code
                )
              }}</template>
            </v-text-field>
          </v-flex>
        </v-layout>
        <v-flex class="px-5" v-show="!onlyCharges">
          <v-divider />
        </v-flex>

        <v-layout my-2 align-center v-show="!isCredit || (isCredit && onlyCharges)">
          <v-flex xs5 offset-xs1>
            <span style="color: #757575;">
              <v-icon small class="pr-1" color="#757575"
                >mdi-bank-transfer</v-icon
              >Bank Charges:
            </span>
          </v-flex>

          <v-flex xs5>
            <v-text-field
              hide-details
              solo
              single-line
              type="number"
              label="Bank Charges"
              class="dense-input"
              background-color="#f4f4f4"
              v-model="currentBankTransaction.charges_amount"
              :disabled="canBeModified"
            >
              <template slot="prepend-inner">{{
                getSymbolFromCode(
                  currencies.find((e) => {
                    return e.id == currentBankInformationCurrencyId;
                  }).code
                )
              }}</template>
            </v-text-field>
          </v-flex>
        </v-layout>
        <v-flex class="px-5" v-show="!isCredit || (isCredit && onlyCharges)">
          <v-divider />
        </v-flex>

        <v-layout my-2 align-center>
          <v-flex xs5 offset-xs1>
            <span style="color: #757575;">
              <v-icon small class="pr-1" color="#757575">mdi-bank</v-icon>Bank
              Account:
            </span>
          </v-flex>

          <v-flex xs5>
            <v-autocomplete
              :items="possibleBankInformations()"
              item-value="id"
              item-text="name"
              v-model="currentBankTransaction.bank_information_id"
              hide-details
              solo
              dense
              single-line
              label="Select Bank Account"
              class="dense-input"
              background-color="#f4f4f4"
              browser-autocomplete="noautocomplete"
              :disabled="canBeModified"
            />
          </v-flex>
        </v-layout>
        <v-flex class="px-5">
          <v-divider />
        </v-flex>

        <v-layout my-2 align-center>
          <v-flex xs5 offset-xs1>
            <span style="color: #757575;">
              <v-icon small class="pr-1" color="#757575">mdi-receipt</v-icon
              >Reference:
            </span>
          </v-flex>

          <v-flex xs5>
            <v-text-field
              hide-details
              solo
              single-line
              label="Please fill Transaction Reference"
              class="dense-input"
              background-color="#f4f4f4"
              v-model="currentBankTransaction.reference"
              :disabled="canBeModified"
            />
          </v-flex>
        </v-layout>
        <v-flex class="px-5">
          <v-divider />
        </v-flex>

        <v-layout my-2 align-center>
          <v-flex xs5 offset-xs1>
            <span style="color: #757575;">
              <v-icon small class="pr-1" color="#757575">event</v-icon
              >Transaction Date:
            </span>
          </v-flex>

          <v-flex xs5>
            <v-menu
              ref="menu"
              :close-on-content-click="true"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
              :disabled="canBeModified"
            >
              <v-text-field
                slot="activator"
                :value="
                  currentBankTransaction.payment_date
                    ? timeToDate(currentBankTransaction.payment_date)
                    : null
                "
                hide-details
                solo
                single-line
                label="Payment Date"
                class="dense-input"
                background-color="#f4f4f4"
                :disabled="canBeModified"
                readonly
              />
              <v-date-picker
                v-model="currentBankTransaction.payment_date"
                no-title
                scrollable
                first-day-of-week="1"
                :disabled="canBeModified"
              />
            </v-menu>
          </v-flex>
        </v-layout>

        <v-layout column v-show="!onlyCharges">
          <v-flex class="px-5">
            <v-divider />
          </v-flex>

          <v-layout my-2 align-center>
            <v-flex xs5 offset-xs1>
              <span style="color: #757575;">
                <v-icon small class="pr-1" color="#757575">store</v-icon>
                {{ isCredit ? "Applicant" : "Beneficiary" }}:
              </span>
            </v-flex>

            <v-flex xs5>
              <v-autocomplete
                :items="companies"
                item-value="id"
                item-text="name"
                v-model="currentBankTransaction.company_id"
                hide-details
                solo
                dense
                single-line
                label="Select a Company"
                class="dense-input"
                background-color="#f4f4f4"
                browser-autocomplete="noautocomplete"
                :disabled="canBeModified"
                @change="currentBankTransaction.affiliate_company_id = ''"
              />
            </v-flex>
          </v-layout>

          <v-flex v-if="availableAffiliatedCompanies.length > 0">
            <v-flex class="px-5">
              <v-divider />
            </v-flex>
            <v-layout my-2 align-center>
              <v-flex xs5 offset-xs1>
                <span style="color: #757575;">
                  <v-icon small class="pr-1" color="#757575">store</v-icon>
                  Affiliated company:
                </span>
              </v-flex>

              <v-flex xs5>
                <v-autocomplete
                  :items="availableAffiliatedCompanies"
                  item-value="id"
                  item-text="name"
                  v-model="currentBankTransaction.affiliate_company_id"
                  hide-details
                  solo
                  dense
                  single-line
                  label="Select an Affiliated Company (Optional)"
                  class="dense-input"
                  background-color="#f4f4f4"
                  browser-autocomplete="noautocomplete"
                  :disabled="canBeModified"
                  clearable
                  @click:clear="
                    currentBankTransaction.affiliate_company_id = ''
                  "
                />
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-layout
          v-show="canBeModified && !currentBankTransaction.onlyCharges"
          row
          wrap
          class="text-xs-center pt-4"
        >
          <v-flex>
            <v-icon small size="12" color="primary" class="pr-1">info</v-icon>
            <v-label>
              This transaction is already reconciled.
              <br />In order to modify it you need to remove the associated
              reconciliation.
            </v-label>
          </v-flex>
        </v-layout>
      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions>
        <v-btn @click="close" small flat color="error">
          <v-icon class="pr-2" small>close</v-icon>Cancel
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          depressed
          small
          :disabled="!canSave"
          @click="save"
          color="success"
        >
          <v-icon class="pr-2" small>save</v-icon>
          {{ actionName }} transaction
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import uploader from "../../shared/uploader";
import dateField from "../../shared/dateField";
import BANK_TRANSACTION_CREATE from "../../../graphql/bank_transactions/create.gql";
import BANK_TRANSACTION_UPDATE from "../../../graphql/bank_transactions/update.gql";
import currency from "../../../mixins/currency";
import date from "../../../mixins/date";
export default {
  name: "transactionForm",
  mixins: [currency, date],
  components: {
    uploader,
    dateField,
  },
  props: {
    subsidiaryCompanyId: {
      type: String,
      required: false
    },
    editedBankTransaction: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      billDialog: false,
      isCredit: true,
      onlyCharges: false,
      currentBankTransaction: null,
      currentBankInformationCurrencyId: null,
      radioState: 0,
    };
  },
  computed: {
    ...mapGetters("commonStore", [
      "affiliateCompanies",
      "bankInformations",
      "companies",
      "currencies",
    ]),
    availableAffiliatedCompanies() {
      if (this.currentBankTransaction.company_id)
        return this.affiliateCompanies.filter(
          (e) => e.company_id === this.currentBankTransaction.company_id
        );
      else return [];
    },
    actionName() {
      return this.editedBankTransaction.id ? "Update" : "Create";
    },
    canSave() {
      if (
        this.canBeModified ||
        (!this.currentBankTransaction.amount && !this.onlyCharges) ||
        (this.currentBankTransaction.amount == 0 && !this.onlyCharges) ||
        !this.currentBankTransaction.reference ||
        (!this.currentBankTransaction.company_id && !this.onlyCharges) ||
        !this.currentBankTransaction.payment_date ||
        !this.currentBankTransaction.bank_information_id ||
        (this.onlyCharges && !this.currentBankTransaction.charges_amount)
      )
        return false;

      return true;
    },
    canBeModified() {
      return (
        this.editedBankTransaction.id &&
        this.editedBankTransaction.reconciliation_status == "done" &&
        this.editedBankTransaction.amount !=
          this.editedBankTransaction.charges_amount
      );
    },
  },
  methods: {
    possibleBankInformations() {
      let bi = this.bankInformations
      if (this.subsidiaryCompanyId) {
        bi = bi.filter(e => e.subsidiary_id == this.companies.filter(c => c.id == this.subsidiaryCompanyId)[0].subsidiary.id)
      }
      return bi
    },
    save() {
      if (!this.currentBankTransaction.affiliate_company_id)
        this.currentBankTransaction.affiliate_company_id = "";
      this.currentBankTransaction.amount = parseFloat(
        this.currentBankTransaction.amount
      );
      this.currentBankTransaction.charges_amount = parseFloat(
        this.currentBankTransaction.charges_amount
      );
      this.currentBankTransaction.operation_type = this.isCredit
        ? "credit"
        : "debit";

      if (this.isCredit && !this.onlyCharges) this.currentBankTransaction.charges_amount = 0;

      if (this.onlyCharges) {
        this.currentBankTransaction.company_id = null;
        this.currentBankTransaction.amount = this.currentBankTransaction.charges_amount;
      }

      if (this.editedBankTransaction.id) {
        var action_name = "updated";
        var mutation = BANK_TRANSACTION_UPDATE;
      } else {
        var action_name = "created";
        var mutation = BANK_TRANSACTION_CREATE;
      }
      this.sendMutation(
        action_name,
        "transaction",
        mutation,
        this.currentBankTransaction
      ).then(() => {
        this.close();
      });
    },
    close() {
      this.$emit("closeBillDialog");
    },
    initBankTransaction() {
      if (this.editedBankTransaction.id) {
        this.isCredit = this.editedBankTransaction.operation_type === "credit";
        this.currentBankTransaction = {
          id: this.editedBankTransaction.id,
          amount: this.editedBankTransaction.amount,
          charges_amount: this.editedBankTransaction.charges_amount,
          reference: this.editedBankTransaction.reference,
          bank_information_id: this.editedBankTransaction.bank_information_id,
          company_id: this.editedBankTransaction.company_id,
          affiliate_company_id: this.editedBankTransaction.affiliate_company_id,
          payment_date: this.editedBankTransaction.payment_date || "",
        };

        //Reset radio
        if (this.isCredit) {
          this.radioState = 0;
          this.isCredit = true;
          this.onlyCharges = false;
        } else {
          this.radioState = 1;
          this.isCredit = false;
          this.onlyCharges = false;

          if (
            this.currentBankTransaction.amount ==
            this.currentBankTransaction.charges_amount
          ) {
            this.radioState = 2;
            this.onlyCharges = true;
          }
        }
      } else {
        let defaultBankInformationId =
          this.possibleBankInformations().length > 0 ? this.possibleBankInformations()[0].id : "";

        //Reset radio
        this.radioState = 0;
        this.isCredit = true;
        this.onlyCharges = false;

        this.currentBankTransaction = {
          reference: "",
          amount: 0,
          charges_amount: 0,
          bank_information_id: defaultBankInformationId,
          company_id: "",
          payment_date: new Date().toISOString().substr(0, 10),
        };
      }
      this.setCurrentCurrency();
    },
    setCurrentCurrency() {
      let bi = this.bankInformations.find((e) => {
        return e.id === this.currentBankTransaction.bank_information_id;
      });
      this.currentBankInformationCurrencyId = bi.currency_id;
    },
  },
  created() {
    this.initBankTransaction();
  },
  watch: {
    radioState() {
      if (this.radioState == 0) {
        this.isCredit = true;
      }

      if (this.radioState == 1) {
        this.isCredit = false;
      }
    },
    editedBankTransaction() {
      this.initBankTransaction();
    },
    "currentBankTransaction.bank_information_id"() {
      this.setCurrentCurrency();
    },
  },
};
</script>

<style lang="stylus" scoped>
td {
  cursor: pointer;
}

.fat-btn {
  height: 70px;
}

.dense-input >>> .v-input__control {
  min-height: 28px !important;
  height: 28px !important;
  font-size: 14px;
}
</style>
